import script from "./Success.vue?vue&type=script&setup=true&lang=js"
export * from "./Success.vue?vue&type=script&setup=true&lang=js"

import "./Success.vue?vue&type=style&index=0&id=c252a270&lang=less"

const __exports__ = script;

export default __exports__